export default "__VITE_ASSET__a0f32460__"